import React from 'react';

const Skills = () => {
  const allSkills = [
    "Content Strategy", "SEO/Keyword Optimization", "Google Analytics", "Content Marketing",
    "Project Management", "Copywriting", "Editorial Management", "Performance Analytics",
    "Team Leadership", "Data Analysis", "Traffic Growth"
  ];

  const tools = [
    "Voltax CMS", "WordPress", "Google Analytics", "Slack", "Git/GitHub"
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2 className="section-title">Skills & Tools</h2>

        <div className="skills-content">
          <div className="all-skills-section">
            <h3>Professional Skills</h3>
            <div className="skills-grid">
              {allSkills.map((skill, index) => (
                <div key={index} className="skill-item">
                  {skill}
                </div>
              ))}
            </div>
          </div>

          <div className="tools-section">
            <h3>Tools & Platforms</h3>
            <div className="tools-grid">
              {tools.map((tool, index) => (
                <div key={index} className="tool-item">
                  {tool}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;